<template>
  <div class="table-wrapper">
    <table class="first-table">
      <tr>
        <th>有休</th>
        <td>{{ dateCounts.paidDayOff.toFixed(1) }} 日</td>
      </tr>
      <tr>
        <th>特別有休</th>
        <td>{{ dateCounts.mDay.toFixed(1) }} 日</td>
      </tr>
      <tr>
        <th>欠勤</th>
        <td>{{ dateCounts.absence.toFixed(1) }} 日</td>
      </tr>
      <tr>
        <th>振出 - 代休</th>
        <td>{{ dateCounts.makeUpHoliday.toFixed(0) }} 日</td>
      </tr>
    </table>
    <table class="second-table">
      <tr>
        <th>在宅</th>
        <td>{{ dateCounts.homeWorkDay || 0}} 日</td>
      </tr>
      <tr v-if="owner.max_home_work_days">
        <th>在宅上限</th>
        <td>{{ owner.max_home_work_days }} 日</td>
      </tr>
    </table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
  },
  computed: {
    ...mapGetters("timesheet", ["dateCounts", "owner"]),
  },
};
</script>

<style lang="scss" scoped>
.table-wrapper {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  background-color: white;
  th,
  td {
    border: solid 1px;
    padding: 5px;
  }
}
</style>